import { defineMessages, defineMessage } from 'react-intl';
import { ENVIRONMENT, MINUTE_IN_SECONDS } from '../../constants';
import { LEFT_PANEL_TABS } from './constants';

export const TAB_LABELS = defineMessages({
  [LEFT_PANEL_TABS.CLIPS]: {
    defaultMessage: 'Clips',
    description: 'Label for Clips',
  },
  [LEFT_PANEL_TABS.SHOTS]: {
    defaultMessage: 'Shots',
    description: 'Label for Shots',
  },
});

export const MESSAGES = defineMessages({
  CLIP_LABEL: {
    defaultMessage: 'Clip {clipNumber}',
    description: 'Label for clip with position',
  },
  SHOT_LABEL: {
    defaultMessage: 'Shot {shotNumber}',
    description: 'Label for show with position',
  },
  UNKNOWN_FRAME_MARKER: {
    defaultMessage: '??:??:??',
    description:
      'Default label shown when no frame time information is known (MM:SS:FF)',
  },
});

export const ERROR_MAP = defineMessages({
  APPEND_VIDEO_FILE: {
    description: 'Error shown when a video file could not be appended',

    defaultMessage: "We couldn't add your video clip.",
    isDismissible: true,
    message: "We couldn't add your video clip.",
    name: 'APPEND_VIDEO_FILE',
  },
  CREATE_EPISODE: {
    description: 'Error shown when video conversion failed',

    defaultMessage: "We couldn't create a new video conversion project.",
    isDismissible: true,
    message: "We couldn't create a new video conversion project.",
    name: 'CREATE_EPISODE',
  },
  EPISODE_DURATION: {
    description: 'Error message shown when selected file is too long for use',
    name: 'EPISODE_DURATION',

    defaultMessage:
      'The selected file must be less than {minutes, plural, =0 {} one {# minute} other {# minutes}} {seconds, plural, =0 {} one {# second} other {# seconds}} long to fit in this project.',
    isDismissible: true,
    values: {
      minutes: Math.floor(
        ENVIRONMENT.DEFAULT_MAX_EPISODE_DURATION_SECONDS / MINUTE_IN_SECONDS,
      ),
      seconds:
        ENVIRONMENT.DEFAULT_MAX_EPISODE_DURATION_SECONDS % MINUTE_IN_SECONDS,
    },
  },
});

export const DISABLED_ADD_CLIP_TOOLTIP = defineMessage({
  defaultMessage: 'Processing video clip…',
  description: ' Shown when video clip is being processed',
});

export const DISABLED_MAX_DURATION_ADD_CLIP_TOOLTIP = defineMessage({
  defaultMessage: 'Project has reached maximum total length.',
  description: 'Shown when project has met or exceeded maximum duration',
});
